import { isValid, format } from 'date-fns';
import { getAllDays, getAllMonths, getYears } from 'components/FormCreatorComponent/helpers';
import {
	fieldMode,
	fieldType,
	fieldsGroupType,
	createFormProps,
	formThemes,
	dependencyAction,
	customValueTypes,
	fieldDependencyType,
} from 'components/FormCreatorComponent/types';
import { pendingRequestsTypes } from 'constants/requests.constants';
import { timing } from 'constants/ui.constants';
import { getFile } from 'services/global.service';
import { ContactLegalStatus, generalTranslation } from 'constants/global.constants';
import { BalanceStatus } from 'constants/balance.constants';

export interface formConfig {
	[key: string]: createFormProps[];
}

export const overrideFormsToProfile = {
	[pendingRequestsTypes.BALANCES]: [
		{
			//name: 'page.pendingRequests.balance.field.requester',
			//handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'approvedBy.id',
								label: 'page.pendingRequests.balance.field.requester',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.hebrewName',
								label: 'page.pendingRequests.balance.field.requester.company.hebrewName',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.companyIdentityNumber',
								label: 'page.pendingRequests.balance.field.requester.company.accountNumber',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.ccId',
								label: 'page.pendingRequests.balance.field.requester.company.ccNumber',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.hyperAccountNumber',
								label: 'page.pendingRequests.balance.field.requester.company.hyperNumber',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bankAccount',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							//type: fieldType.custom,
							//mode: fieldMode.readonly,
							props: {
								name: 'bankAccount.id',
								//label: 'page.pendingRequests.balance.field.bankAccount.description',
								//required: true,
								disabled: true,
								//customComponent: BankAccountsDetails,
								// customData: {
								// 	accounts: [
								// 		{
								// 			id: 1,
								// 			companyId: 1,
								// 			accountOwnerName: 'Uzi Shalom',
								// 			reference: 'iuiuiu',
								// 			bankOrigin: 'aaaaaa',
								// 			bankBranch: 'branch me',
								// 			accountNumber: '426144',
								// 			bankName: {
								// 				bankName: 'eumi',
								// 			},
								// 			currencyId: 16,
								// 		},
								// 	],
								// 	handleBankPick: () => {},
								// 	selectedAccountId: null,
								// },
							},
							//validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.altshulerBankAccount',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// 	type: fieldType.custom,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'altshulerAccountId',
								// 		label: 'page.pendingRequests.balance.field.altshulerBankAccount.description',
								// 		required: true,
								disabled: true,
								// 		customComponent: BankAccountsDetails,
								// 		customData: {
								// 			accounts: [
								// 				{
								// 					id: 1,
								// 					companyId: 1,
								// 					accountOwnerName: 'Uzi Shalom',
								// 					reference: 'iuiuiu',
								// 					bankOrigin: 'aaaaaa',
								// 					bankBranch: 'branch me',
								// 					accountNumber: '426144',
								// 					bankName: {
								// 						bankName: 'eumi',
								// 					},
								// 					currencyId: 16,
								// 				},
								// 			],
								// 			handleBankPick: () => {},
								// 			selectedAccountId: null,
								// 		},
							},
							// 	validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			//handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								label: 'page.pendingRequests.balance.field.createdAt',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
						},

						{
							// 	type: fieldType.select,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'currency.id',
								// 		label: 'page.pendingRequests.balance.field.currency',
								// 		options: [{ label: 'bbbb', value: 'cccc' }],
								// 		required: true,
								disabled: true,
							},
							// 	validation: [{ requierd: true }],
						},
						{
							// 	type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								// 		name: 'amount',
								// 		label: 'page.pendingRequests.balance.field.amount',
								// 		required: true,

								disabled: true,
							},
							// 	validation: [{ requierd: true }, { integer: true }],
						},
						{
							mode: fieldMode.readonly,
							props: {
								name: 'file',
								disabled: true,
								onClick: (file: any) => {
									getFile(file?.key, file?.companyId);
								},
							},
							dependency: { name: 'file', value: null, type: fieldDependencyType.isEmpty },
						},
						// {
						// 	// 	type: fieldType.checkbox,
						// 	props: {
						// 		name: 'houseAccountTransferCheck',
						// 		// 		label: 'page.pendingRequests.balance.field.houseAccountTransfer',
						// 		//required: false,
						// 		disabled: true,
						// 	},
						// 	// 	validation: [{ checked: true }],
						// },
						{
							// 	type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'ccHouseAccountTransferReference',
								// 		label: 'page.pendingRequests.balance.field.reference',
								// 		required: false,
								// dependency: null,
								// dependencyAction: null,

								disabled: true,
							},
							dependency: {
								name: 'ccHouseAccountTransferReference',
								value: null,
								type: fieldDependencyType.isEmpty,
							},
							// dependency: { name: 'houseAccountTransferCheck', value: 'true' },
							// dependencyAction: dependencyAction.none,
							// 	validation: [{ requierd: false }],
						},
						// {
						// 	mode: fieldMode.readonly,
						// 	props: {
						// 		name: 'status',
						// 		disabled: true,
						// 	},
						// 	dependency: { name: 'status', value: null, type: fieldDependencyType.isEmpty },
						// 	customValue: (value: any) => generalTranslation[value],
						// },
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'feezbackUpdatedAt',
								label: 'page.digitalBalanceRequests.field.feezbackUpdatedAt',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
							dependencyAction: dependencyAction.hide,
							dependency: {
								name: 'feezbackUpdatedAt',
								value: null,
								type: fieldDependencyType.isEmpty,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'status',
								label: 'page.pendingRequests.balance.field.status',
								options: Object.values(BalanceStatus)
									.filter((status) =>
										[
											BalanceStatus.Pending,
											BalanceStatus.Rejected,
											BalanceStatus.Completed,
										].includes(status)
									)
									.map((status: any) => ({
										label: `label.${status.toLowerCase()}`,
										value: status,
									})),
								required: true,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.companyManagement',
			theme: formThemes.hiddenInputs,
			hide: false,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.manager.name',
								label: 'page.pendingRequests.balance.field.requester.company.manager',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.dealer.name',
								label: 'page.pendingRequests.balance.field.requester.company.dealer',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.agent.name',
								label: 'page.pendingRequests.balance.field.requester.company.agent',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.lead.name',
								label: 'page.pendingRequests.balance.field.requester.company.lead',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.requester',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'boApprovedByUser', value: null, type: fieldDependencyType.isEmpty },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.firstBoSigner',
			hide: false,
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boSecondarySignerApprovalDate',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.date',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boNotes',
								label: 'page.customerAccounts.forms.balance.accountManagement.rejectReason',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'boNotes', value: '.+' },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.secondBoSigner',
			hide: false,
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boSecondaryBoSignerApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByDate',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.date',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boNotes',
								label: 'page.customerAccounts.forms.balance.accountManagement.rejectReason',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'boNotes', value: '.+' },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.RejectedBoSigner',
			hide: false,
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boADeclinedByUser',
								label: 'page.pendingRequests.balance.field.bo.signer.reject.name',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boDeclinedDate',
								label: 'page.pendingRequests.balance.field.bo.signer.reject.date',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boNotes',
								label: 'page.customerAccounts.forms.balance.accountManagement.rejectReason',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'boNotes', value: '.+' },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			hide: true,
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// 	type: fieldType.checkbox,
							props: {
								// 		name: 'approveTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.title',
								// 		required: false,
								disabled: true,
							},
							// 	validation: [{ checked: true }],
						},
						{
							// 	type: fieldType.label,
							// 	mode: fieldMode.readWithEnableWrite,
							props: {
								// 		name: 'approveSubTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.subtitle',
								// 		required: false,
								disabled: true,
							},
							// 	validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bo.confirm.mainTitle',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'selectApproveTitleNumber',
								label: 'page.pendingRequests.balance.field.bo.confirm.of.one',
								required: false,
								disabled: false,
							},
							validation: [],
						},
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'selectApproveTitle',
								label: 'page.pendingRequests.balance.field.bo.confirm.subtitle',
								required: false,
								disabled: false,
							},
							validation: [],
						},
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'selectApprove',
								label: ' ',
								options: [
									{
										value: 'Approve',
										label: 'label.approved',
										disabled: false,
									},
									{
										value: 'NotApprove',
										label: 'label.notApproved',
										disabled: false,
									},
								],
								required: false,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.CONTACTS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameHebrew',
								label: 'label.firstName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameHebrew',
								label: 'label.lastName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstName',
								label: 'label.firstNameEnglish',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastName',
								label: 'label.lastNameEnglish',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'label.birthDate',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'day',
								label: 'label.day',
								options: getAllDays(),
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'month',
								label: 'label.month',
								options: getAllMonths(),
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'year',
								label: 'label.year',
								options: getYears(),
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'legalStatus',
								label: 'label.publicFigure',
								options: [
									{ value: ContactLegalStatus.Legal, label: 'label.yes', disabled: true },
									{ value: ContactLegalStatus.NotLegal, label: 'label.no', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
								options: [
									{ value: 'ID', label: 'label.identicationId', disabled: true },
									{ value: 'Passport', label: 'label.Passport', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'gender',
								label: 'label.gender',
								options: [
									{ value: 'Male', label: 'label.male', disabled: true },
									{ value: 'Female', label: 'label.female', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'email',
								label: 'label.email',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }, { email: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phone',
								label: 'label.phone',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }, { phone: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'country.name',
								label: 'label.country',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'role',
								label: 'label.role',
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'permission',
								label: 'label.permisionLevel',
								options: [{ label: '', value: '1' }],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.BANK_ACCOUNTS]: [
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			theme: formThemes.hiddenInputs,
			// fieldsGroups: [
			// 	{
			// 		type: fieldsGroupType.col,
			// 		fields: [
			// 			{
			// 				type: fieldType.text,
			// 				mode: fieldMode.readWithEnableWrite,
			// 				props: {
			// 					name: 'accountOwnerName',
			// 					label: 'page.pendingRequests.field.accountOwnerName',
			// 					required: true,
			// 					disabled: false,
			// 				},
			// 				validation: [{ requierd: true }],
			// 			},
			// 			{
			// 				type: fieldType.text,
			// 				mode: fieldMode.readonly,
			// 				props: {
			// 					name: 'bankName.bankName',
			// 					label: 'page.pendingRequests.field.bankName',
			// 					required: true,
			// 					disabled: false,
			// 				},
			// 				validation: [{ requierd: true }],
			// 			},
			// 			{
			// 				type: fieldType.text,
			// 				mode: fieldMode.readonly,
			// 				props: {
			// 					name: 'bankId',
			// 					label: 'page.pendingRequests.field.bankId',
			// 					required: true,
			// 					disabled: false,
			// 				},
			// 				validation: [{ requierd: true }],
			// 			},
			// 			{
			// 				type: fieldType.text,
			// 				mode: fieldMode.readonly,
			// 				props: {
			// 					name: 'bankBranch',
			// 					label: 'page.pendingRequests.field.bankBranch',
			// 					required: true,
			// 					disabled: false,
			// 				},
			// 				validation: [{ requierd: true }],
			// 			},
			// 			{
			// 				type: fieldType.text,
			// 				mode: fieldMode.readWithEnableWrite,
			// 				props: {
			// 					name: 'accountNumber',
			// 					label: 'page.pendingRequests.field.accountNumber',
			// 					required: true,
			// 					disabled: false,
			// 				},
			// 				validation: [{ requierd: true }],
			// 			},
			// 		],
			// 	},
			// ],
		},
		// {
		// 	name: 'page.managePendingRequests.forms.approveAccount',
		// 	handleChange: () => {},
		// 	fieldsGroups: [
		// 		{
		// 			type: fieldsGroupType.col,
		// 			fields: [
		// 				{
		// 					type: fieldType.file,
		// 					mode: fieldMode.readWithEnableWrite,
		// 					props: {
		// 						name: 'file',
		// 						label: '',
		// 						required: true,
		// 					},
		// 					validation: [{ requierd: true }],
		// 				},
		// 			],
		// 		},
		// 	],
		// },
	],
	[pendingRequestsTypes.BENEFICIARIES]: [
		{
			name: 'page.managePendingRequests.forms.beneficiaryDetails',
			handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'type',
								label: 'label.beneficiaryType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstName',
								label: 'label.firstName',
								disabled: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastName',
								label: 'label.lastName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'companyName',
								label: 'label.companyName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'type', value: 'Company' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'nickname',
								label: 'label.nickname',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'country.name',
								label: 'label.country',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankAccountHolderName',
								label: 'label.bankAccountHolderName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'accountNumber',
								label: 'label.accountNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankAccountCountry.name',
								label: 'label.bankAccountCountry',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankAccountCity',
								label: 'label.bankAccountCity',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankAccountAddress',
								label: 'label.bankAccountAddress',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bicSwift',
								label: 'label.bicSwift',
								required: true,
								disabled: true,
							},
							dependency: { name: 'bicSwift', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'iban',
								label: 'label.iban',
								required: true,
								disabled: true,
							},
							dependency: { name: 'iban', value: '.+' },
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.GENERAL_SUPPORT]: [],
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: [
		{
			//name: 'page.pendingRequests.balance.field.requester',
			//handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdBy.fullName',
								label: 'page.pendingRequests.balance.field.requester',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.hebrewName',
								label: 'page.pendingRequests.balance.field.requester.company.hebrewName',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.companyIdentityNumber',
								label: 'page.pendingRequests.balance.field.requester.company.accountNumber',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.ccId',
								label: 'page.pendingRequests.balance.field.requester.company.ccNumber',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.hyperAccountNumber',
								label: 'page.pendingRequests.balance.field.requester.company.hyperNumber',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			//handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								label: 'page.pendingRequests.balance.field.createdAt',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
						{
							// 	type: fieldType.select,
							// 	mode: fieldMode.readonly,
							props: {
								name: 'currency.id',
								// 		label: 'page.pendingRequests.balance.field.currency',
								// 		options: [{ label: 'bbbb', value: 'cccc' }],
								// 		required: true,
								disabled: true,
							},
							// 	validation: [{ requierd: true }],
						},
						{
							// 	type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								// 		name: 'amount',
								// 		label: 'page.pendingRequests.balance.field.amount',
								// 		required: true,

								disabled: true,
							},
							// 	validation: [{ requierd: true }, { integer: true }],
						},
						{
							// 	type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								// 		name: 'amount',
								// 		label: 'page.pendingRequests.balance.field.amount',
								// 		required: true,

								disabled: true,
							},
							// 	validation: [{ requierd: true }, { integer: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'bankName',
								options: [],
								//label: 'page.pendingRequests.balance.field.accountForWithdrawal',
								required: false,
								disabled: false,
							},
							//validation: [],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.companyManagement',
			theme: formThemes.hiddenInputs,
			hide: false,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.manager.name',
								label: 'page.pendingRequests.balance.field.requester.company.manager',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.dealer.name',
								label: 'page.pendingRequests.balance.field.requester.company.dealer',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.agent.name',
								label: 'page.pendingRequests.balance.field.requester.company.agent',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.lead.name',
								label: 'page.pendingRequests.balance.field.requester.company.lead',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.requester',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.firstBoSigner',
			hide: false,
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByDate',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.date',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.RejectedBoSigner',
			hide: false,
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boADeclinedByUser',
								label: 'page.pendingRequests.balance.field.bo.signer.reject.name',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boDeclinedDate',
								label: 'page.pendingRequests.balance.field.bo.signer.reject.date',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.FULLDATE) : value,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boNotes',
								label: 'page.customerAccounts.forms.balance.accountManagement.rejectReason',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'boNotes', value: '.+' },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			hide: true,
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						{
							// 	type: fieldType.checkbox,
							props: {
								// 		name: 'approveTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.title',
								// 		required: false,
								disabled: true,
							},
							// 	validation: [{ checked: true }],
						},
						{
							// 	type: fieldType.label,
							// 	mode: fieldMode.readWithEnableWrite,
							props: {
								// 		name: 'approveSubTitle',
								// 		label: 'page.pendingRequests.balance.field.confirm.subtitle',
								// 		required: false,
								disabled: true,
							},
							// 	validation: [{ requierd: false }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bo.confirm.mainTitle',
			//handleChange: () => {},
			fieldsGroups: [
				{
					//type: fieldsGroupType.col,
					fields: [
						/*{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'selectApproveTitleNumber',
								label: 'page.pendingRequests.balance.field.bo.confirm.of.two',
								required: false,
								disabled: false,
							},
							validation: [],
						},*/
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'selectApproveTitle',
								label: 'page.pendingRequests.balance.field.bo.confirm.subtitle',
								required: false,
								disabled: false,
							},
							validation: [],
						},
						{
							type: fieldType.radio,
							mode: fieldMode.write,
							props: {
								name: 'selectApprove',
								label: ' ',
								options: [
									{
										value: 'Approve',
										label: 'label.approved',
										disabled: false,
									},
									{
										value: 'NotApprove',
										label: 'label.notApproved',
										disabled: false,
									},
								],
								required: false,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.PAYMENTS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			theme: formThemes.hiddenInputs,
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'requestedByCompany.name',
								label: 'label.companyNameHebrew',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.englishName',
								label: 'label.companyNameEnglish',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstName',
								label: 'label.firstName',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastName',
								label: 'label.lastName',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.company',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'role',
								label: 'label.role',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'legalStatus',
								label: 'label.legalStatus',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'gender',
								label: 'label.gender',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.maxForPayment',
								label: 'label.maxForPayment',
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'requestedByCompany.maxForConvert',
								label: 'label.maxForConvert',
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'email',
								label: 'label.email',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phone',
								label: 'label.phone',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.address',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'country.name',
								label: 'label.country',
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
};
